import { PlatformPage } from './PlatformPage'
import { platformFeatures } from '@/data/platform'

export default function AIGeneration() {
  return <PlatformPage feature={platformFeatures['ai-generation']!} />
}
